import { api } from "..";
import { SimpleSuccessResponse } from "./types";

export const deleteChatForMe = async (
  chatId: number
): Promise<SimpleSuccessResponse> => {
  const res = await api.client.delete(`/chats/${chatId}`);
  return res.data;
};
